export default "__VITE_ASSET__286c858f__"